import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3cd5ab83&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5ab83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd5ab83')) {
      api.createRecord('3cd5ab83', component.options)
    } else {
      api.reload('3cd5ab83', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3cd5ab83&scoped=true", function () {
      api.rerender('3cd5ab83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/index.vue"
export default component.exports